<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  },
  mounted: function () {
    if (localStorage.getItem('token') === null) {
      this.$router.push('/')
    }
  }
}
</script>

<style>
@import url('./assets/css/font-awesome.min.css');
</style>



// WEBPACK FOOTER //
// src/App.vue